import React, { Component } from 'react';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import axios from '../../../../data/http/axios';
import i18n from '~/i18n';

class Suggestion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: '',
            details: '',
            msg: ''
        }

        this.update = this.update.bind(this)
        this.send = this.send.bind(this)
    }

    update(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    send() {
        axios.post('/suggestion', { type: this.state.type, details: this.state.details }).then(() => {
            this.setState({
                msg: i18n.t('support:suggestion.successMessage')
            }, () => {
                setTimeout(this.props.finish, 2000)
            })
        })
    }

    render() {
        var types = [
            { label: i18n.t('support:suggestion.categoryIntegration'), value: 'Integration' },
            { label: i18n.t('support:suggestion.categoryFeature'), value: 'Feature' },
            { label: i18n.t('support:suggestion.categoryOther'), value: 'Other' }
        ]

        return (
            <div>
                <h4 className="mar-b25">{i18n.t('support:suggestion.title')}</h4>

                <Select outerClassName="mar-b25" label={i18n.t('support:suggestion.category')} data={types} placeholder={i18n.t('support:suggestion.selectCategory')} name="type" value={this.state.type} onChange={this.update}></Select>

                <TextArea label={i18n.t('support:suggestion.request')} outerClassName="mar-b25" rows="5" placeholder={i18n.t('support:suggestion.detailsPlaceholder')} name="details" value={this.state.details} onChange={this.update}></TextArea>
                <Button className="button-primary" disabled={!this.state.type || !this.state.details} onClick={this.send}>{i18n.t('send')}</Button>
                {!!this.state.msg && <p className="text-sml mar-t10">{this.state.msg}</p>}
            </div >
        );
    }
}

export default Suggestion;
